import React, { Component } from 'react'
import { apiProcess } from '../../../api/api.js'
import * as Yup from 'yup'
import { RESUME } from '../main/constants.js'
import { Field, Header, Button } from 'components/elements/index.js'
import './insuranceScreen.css'

const resumeValidation = Yup.object().shape({
  riderResume: Yup.string()
    .nullable()
    .required('Rider resume is required.'),
})

class RiderResumeScreen extends Component {
  constructor(props) {
    super(props)
    this.state = {
      resumeError: false,
      generalError: false,
      riderResume: '',
      loading: false,
    }
  }

  componentDidMount() {
    this.props.onScreenLoad(RESUME)
  }

  checkRidingResume = () => {
    this.setState({
      resumeError: false,
      loading: true,
    })

    resumeValidation
      .validate(
        {
          riderResume: this.state.riderResume,
        },
        { abortEarly: false }
      )
      .then(
        function(valid) {
          this.processResume()
        }.bind(this)
      )
      .catch(
        function(responseData) {
          this.setState({
            resumeError: 'You must enter information about yourself!',
            loading: false,
          })
        }.bind(this)
      )
  }

  processResume = () => {
    let apiURL = 'users/basic_info'

    let profileData = {
      rider: {
        rider_resume: this.state.riderResume,
      },
    }

    apiProcess(
      apiURL,
      profileData,
      'update-profile',
      'Update Profile - Rider Resume - Info Wizard'
    )
      .then(
        function(responseData) {
          this.setState({
            generalError: false,
            resumeError: false,
            loading: false,
          })
          this.props.onSuccess()
        }.bind(this)
      )
      .catch(
        function(responseData) {
          this.setState({
            generalError: 'Sorry we are having problems right now',
            loading: false,
          })

          //alert('check this when the API works again')
          // this.props.onSuccess()
          //any errors we parse here.
        }.bind(this)
      )
  }

  render() {
    const { generalError, resumeError, riderResume, loading } = this.state

    return (
      <React.Fragment>
        <div className="has-text-centered">
          {generalError && (
            <div className="has-text-danger">{generalError}</div>
          )}
          <Header
            size={4}
            renderas="h2"
            className="has-text-weight-bold is-spaced mb-1"
          >
            {this.props.header}
          </Header>
          <Header subtitle size={6}>
            Tell us a little more about yourself.
          </Header>

          <Field
            name="riderResume"
            id="riderResume"
            error={resumeError}
            onChange={
              ({ value }) =>
                this.setState({
                  riderResume: value,
                  resumeError: false,
                })
              //this.handleMakeChange(data.value)
            }
            value={riderResume}
            type="textarea"
            showErrors={false}
          />
          {resumeError && (
            <div className="has-text-danger mb-2">{resumeError}</div>
          )}
          <Button
            color="primary"
            loading={loading}
            disabled={loading}
            className="button-with-bottom-margin"
            fullwidth
            size="medium"
            onClick={() => this.checkRidingResume()}
          >
            Submit
          </Button>
          {this.props.skippable && (
            <span
              onClick={() => this.props.onSuccess()}
              className="finger-pointer customTopPadding"
            >
              I'll do this later
            </span>
          )}
        </div>
      </React.Fragment>
    )
  }
}

export default RiderResumeScreen

RiderResumeScreen.defaultProps = {
  onSuccess: function() {},
  skippable: true,
  header: 'About You',
  onScreenLoad: function() {},
}
